<template>
  <div>
    <div class="summary-container">
      <div
        v-for="(objectData, index) of arrayFilledDataSortedByPriority"
        :key="index"
        class="summary-container__block-stats"
      >
        <div class="summary-container__block-stats__title-section">{{ objectData.name }}</div>
        <ItemBar
          v-for="(objectSubcategory, index) of objectData.subcategories"
          :key="100 + index"
          :title="objectSubcategory.name"
          :subcategory="objectSubcategory"
          @click-bar="onClickBar($event, objectSubcategory)"
        />
      </div>
    </div>
    <ResumeTooltip
      :data="tooltip.data"
      :local="tooltip.local"
      :names="tooltip.names"
      :keyName="tooltip.keyName"
      :leagueAvg="tooltip.leagueAvg"
      :left="tooltip.local"
      :show.sync="tooltip.show"
      :x="tooltip.x"
      :y="tooltip.y"
      :data-value="tooltip.numberValue"
      :is-percent="tooltip.booleanIsPercent"
      :is-league-avg-visible="tooltip.isLeagueAvgVisible"
    />
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import { avg } from '@/utils/league';

export default {
  name: 'Summary',
  components: {
    ItemBar: () => import('@/components/Sections/Statistics/ItemBar'),
    ResumeTooltip: () => import('@/components/Elements/NextMatches/ResumeTooltip'),
  },
  props: {
    isFromBet: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tooltip: {
        show: false,
        data: {},
        names: {},
        keyName: '',
        leagueAvg: '',
        local: false,
        x: 0,
        y: 0,
      },
    };
  },
  computed: {
    ...mapState('general', ['tournamentSelected']),
    ...mapState('nextGeneral', ['selectedAnalysis', 'currentTournamentName', 'gameForAnalysis']),
    ...mapState('loginGeneral', ['user']),
    ...mapGetters('nextGeneral', [
      'isLive',
      'showLiveData',
      'showPostMatchData',
      'statisticData',
      'homeTeamStatisticsType',
      'visitingTeamStatisticsType',
      'subcategoryName',
      'accomplished',
      'filledDataStructure',
      'betSubcategoriesIds',
      'arrayFilledDataSortedByPriority',
    ]),
    filteredSubcategories() {
      if (this.isFromBet) {
        const betSubcategories = Object.values(this.filledDataStructure).reduce((accumulator, category) => {
          Object.values(category.subcategories).forEach(subcategory => {
            if (this.betSubcategoriesIds.includes(subcategory.generalId)) {
              accumulator.push(subcategory);
            }
          });
          return accumulator;
        }, []);
        this.setBetSubcategoriesObjects(betSubcategories);
        return betSubcategories;
      }
      return this.statisticData;
    },
    awayTeamDataClasses() {
      return [
        this.isMobile ? 'mobile-column-right' : 'margin-right-12',
        !this.user.premiumAccount && this.isFromBet ? 'blurred' : '',
      ];
    },
    homeTeamDataClasses() {
      return [
        this.isMobile ? 'mobile-column-left' : 'margin-left-12',
        !this.user.premiumAccount && this.isFromBet ? 'blurred' : '',
      ];
    },
    showAvg() {
      if (!this.showPostMatchData) {
        return this.subcategoryName === '1-1' || this.subcategoryName === '0-0';
      } else {
        return false;
      }
    },
    isMobile() {
      return this.$mq === 'mobile';
    },
  },
  methods: {
    ...mapMutations('nextGeneral', ['setBetSubcategoriesObjects']),
    showModal(event, data, leagueAvg, names, local, numberValue = 0, booleanIsPercent = false, stringSubcategoryId) {
      this.tooltip.data = data;
      this.tooltip.local = local;
      this.tooltip.names = names;
      this.tooltip.keyName = this.subcategoryName;
      this.tooltip.leagueAvg = leagueAvg;
      this.tooltip.x = event.pageX;
      this.tooltip.y = event.clientY + 235 > window.innerHeight ? event.clientY - 235 : event.clientY;
      /*if (!this.showPostMatchData) {
        this.tooltip.y = /!*event.pageY > 700 ? event.pageY - 350 : *!/event.clientY;
      } else {
        this.tooltip.y = event.pageY > 700 ? event.pageY - 70 : event.pageY;
      }*/
      this.tooltip.numberValue = numberValue;
      this.tooltip.booleanIsPercent = booleanIsPercent;
      // 3-0 is possession's id
      this.tooltip.isLeagueAvgVisible = stringSubcategoryId !== '3-0';
      this.tooltip.show = true;
    },
    leagueAvg(subcategory) {
      if (subcategory.generalCategoriesIds.accomplished === 3) {
        return (
          (subcategory.homeTeam.accomplished.arrayRankings.reduce((accumulator, objectRankingData) => {
            return accumulator + objectRankingData.points;
          }, 0) /
            subcategory.homeTeam.accomplished.arrayRankings.length) *
          100
        ).toFixed(2);
      } else {
        return avg(subcategory, this.accomplished);
      }
    },
    getSubcategoryData(objectSubcategory, stringTeamType = 'homeTeam') {
      // possession id is 3-0
      if (objectSubcategory.id === '3-0') {
        objectSubcategory[stringTeamType].accomplished.totalLiveBothTeams =
          objectSubcategory.homeTeam.accomplished.totalLive + objectSubcategory.visitingTeam.accomplished.totalLive;
      }
      return objectSubcategory[stringTeamType].accomplished || 0;
    },
    onClickBar(objectData, objectSubcategory) {
      this.showModal(
        objectData.objectEventClick || null,
        this.getSubcategoryData(objectSubcategory, objectData.stringTeamType),
        this.leagueAvg(objectSubcategory) || 0,
        objectSubcategory.names || null,
        objectData.stringTeamType === 'homeTeam',
        objectData.numberValue || 0,
        objectSubcategory.generalCategoriesIds.accomplished === 3,
        objectSubcategory.id,
      );
    },
  },
};
</script>

<style scoped lang="scss">
.summary-container {
  width: 100%;
  height: auto;
  margin-bottom: 45px;
  padding-bottom: 30px;
  @media screen and (max-width: 540px) {
    margin-bottom: 5px;
    padding-bottom: 0px;
  }
  &__block-stats {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
    @media screen and (max-width: 640px) {
      border-radius: 16px;
      border: solid 2px #eff4f9;
      margin-bottom: 45px;
      padding-bottom: 30px;
    }

    &__title-section {
      width: 881px;
      height: 58px;
      // background: rgb(51, 77, 0);
      margin: 0 auto;
      font-family: 'Avenir-Bold';
      font-size: 28px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 58px;
      letter-spacing: normal;
      text-align: center;
      color: #000;
      margin-top: 2px;
      @media screen and (max-width: 1140px) {
        width: 94%;
        font-size: 27px;
      }
      @media screen and (max-width: 940px) {
        font-size: 25px;
      }
      @media screen and (max-width: 740px) {
        font-size: 23px;
      }
      @media screen and (max-width: 640px) {
        border-bottom: solid 2px #eff4f9;
        width: 100%;
        font-size: 21px;
      }
      @media screen and (max-width: 540px) {
        font-size: 19px;
      }
      @media screen and (max-width: 440px) {
        font-size: 17px;
      }
    }
  }
}
$blur: 10px;
.has-divider-vertical {
  height: auto;
  border-left: 1px dotted #bebcbc;
  margin-top: 1.4rem;
  margin-bottom: 1.4rem;
}

.has-horizontal-divider {
  border-bottom: 1px solid #d7d7d7;
}

.category-name {
  font-family: 'Circular-Std';
  font-size: 1.063rem;
}

.team-data {
  position: relative;

  &.blurred {
    filter: blur($blur);
    -webkit-filter: blur($blur);
    background-color: rgba(255, 255, 255, 0.1);
    z-index: 1;
  }
}

@media (max-width: 400px) {
  .category-name {
    font-size: 1rem !important;
  }
  .category-postmatch-value-left {
    font-size: 24px !important;
    width: 32px;
  }
  .category-postmatch-value-right {
    font-size: 24px !important;
    width: 32px;
  }
  .category-postmatch-value-righ-indiv {
    text-align: right;
    width: 52px;
    float: right;
  }
  .category-live-value {
    font-size: 24px !important;
    width: 34px;
  }
}

@media (max-width: 350px) {
  .category-name {
    font-size: 0.8rem !important;
  }
  .category-postmatch-value-left {
    font-size: 24px !important;
    width: 30px;
  }
  .category-postmatch-value-right {
    font-size: 24px !important;
    width: 30px;
  }
  .category-live-value {
    font-size: 24px !important;
    width: 30px;
  }
}

.category-league-average {
  font-family: 'Avenir-Demi';
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.002rem;
}

.category-postmatch-value-left {
  text-align: left;
  font-family: 'Circular-Std';
  font-size: 29px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  color: black;
}

.category-postmatch-value-right {
  text-align: right;
  font-family: 'Circular-Std';
  font-size: 29px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  color: black;
}

.category-live-value {
  margin: 0 8px;
  font-family: 'Circular-Std';
  font-size: 29px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.005rem;
  text-align: center;
  color: #ffffff;
  background-color: #77a405;
  border-radius: 8px;
  min-width: 46px;
}

.category-ranking {
  font-family: 'Avenir-Demi';
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  color: #5e5e5e;
}

.category-annotation {
  font-family: 'Avenir-Demi';
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.54;
  color: #ffffff;
  background-color: #77ba3f;
  text-align: center;
}

.margin-bottom-12 {
  margin-bottom: calc(1.5rem - 0.75rem) !important;
}

.margin-left-12 {
  margin-left: 1rem !important;
}

.margin-right-12 {
  margin-right: 1rem !important;
}

.data-container {
  display: flex;
}

.mobile-column-center {
  padding: 12px 4px 12px 4px;
}

.mobile-column-left {
  padding: 12px 0 12px 0;
}

.mobile-column-right {
  padding: 12px 0 12px 0;
}

.category-postmatch-value-left:hover,
.category-postmatch-value-right:hover {
  color: #77a405 !important;
}
.category-live-value:hover {
  background-color: #658909;
}
</style>
